import React from 'react';
import NotesIcon from '@mui/icons-material/Notes';
import AppsIcon from '@mui/icons-material/Apps';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import { TipoSecaoHome } from '../../../../model/apm/apm-enums';

export const HOME_SECTION_ICONS: Record<TipoSecaoHome, React.ReactElement> = {
    [TipoSecaoHome.Banners]: <ViewCarouselIcon />,
    [TipoSecaoHome.DiarioOficial]: <MenuBookIcon />,
    [TipoSecaoHome.Noticias]: <NewspaperIcon />,
    [TipoSecaoHome.TextoLivre]: <NotesIcon />,
    [TipoSecaoHome.AcessoRapido]: <AppsIcon />,
    [TipoSecaoHome.CardDestaque]: <ViewModuleIcon />,
    [TipoSecaoHome.Videos]: <SmartDisplayIcon />,
};
